/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import * as React from 'react'
import { Text, Button, Icon, Tooltip } from '@components/atoms'

import { grey } from '@mui/material/colors'
import { ButtonPropsColorOverrides } from '@mui/material'
import { OverridableStringUnion } from '@mui/types'

interface PropsType {
	title?: string
	className?: string
	style?: React.CSSProperties
	tooltip?: string
	buttonColor?: OverridableStringUnion<
		'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning',
		ButtonPropsColorOverrides
	>
	onClick?: () => void
	iconName?: string
	iconTextColor?: string
	disabled?: boolean
	variant?: 'contained' | 'outlined' | 'text'
	shouldPreventDuplicatedClick?: boolean
}

export const ActionButton = (props: PropsType) => {
	const buttonColor = props.buttonColor ?? 'inherit'
	const variant = props.variant ?? 'text'
	const iconColor = props.iconTextColor
		? props.iconTextColor
		: buttonColor === 'inherit'
		? grey[800]
		: variant !== 'text'
		? 'white'
		: grey[800]

	return (
		<Tooltip title={props.tooltip ?? props.title}>
			<Button
				className={props.className ?? ''}
				css={[style, props.variant ? null : { background: grey[50] }, { ...props.style }]}
				size="small"
				color={buttonColor}
				onClick={props.onClick}
				shouldPreventDuplicatedClick={props.shouldPreventDuplicatedClick}
				disabled={props.disabled ?? false}
				variant={props.variant ?? 'text'}
			>
				<Icon
					name={props.iconName ?? 'check'}
					className="actionButtonIcon"
					css={{
						color: iconColor,
						marginRight: props.title !== undefined ? '0.5rem' : 0,
						opacity: props.disabled ? 0.3 : 1,
					}}
				/>

				<Text className="actionButtonTitle">{props.title}</Text>
			</Button>
		</Tooltip>
	)
}

const style = css({
	height: '1.9rem',
	minWidth: '1.5rem',
	margin: '0 0.2rem',
	padding: '0.1rem 0.4rem',

	'.actionButtonIcon': {
		fontSize: '22px',
	},

	'.actionButtonTitle': {
		margin: 0,
		padding: 0,
	},
})
